import React from 'react';
import {FormControl, FormHelperText, Input, InputLabel} from "material-ui";

export const renderTextField = ({
                                    input,
                                    meta: {touched, error},
                                    ...custom
                                }) => (

    <FormControl fullWidth
                 margin="normal"
                 error={custom.err !== undefined && custom.err !== null}>
        {custom.label !== undefined ? <InputLabel>{custom.label}</InputLabel> : null}
        <Input
            {...input}
            {...custom}
        />
        {custom.err !== undefined && custom.err !== null ?
            custom.err.map((n, i) =>
                <FormHelperText key={i}>{n}</FormHelperText>) : null}
    </FormControl>
);


// WEBPACK FOOTER //
// ./src/forms/inputs/TextFeaild.js